import { useEffect, useRef, useState } from 'react';

/**
 * Triggers `revealed = true` once the element enters the viewport.
 * One-shot — does not re-run on scroll out.
 */
export const useReveal = ({ threshold = 0.12, rootMargin = '0px 0px -8% 0px' } = {}) => {
  const ref = useRef(null);
  const [revealed, setRevealed] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node || revealed) return;

    if (typeof IntersectionObserver === 'undefined') {
      setRevealed(true);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            setRevealed(true);
            observer.disconnect();
            break;
          }
        }
      },
      { threshold, rootMargin }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [threshold, rootMargin, revealed]);

  return [ref, revealed];
};
